/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MovePrescriptionStartDateDialog.vue?vue&type=template&id=77e1207c&scoped=true"
import script from "./MovePrescriptionStartDateDialog.vue?vue&type=script&lang=js"
export * from "./MovePrescriptionStartDateDialog.vue?vue&type=script&lang=js"
import style0 from "./MovePrescriptionStartDateDialog.vue?vue&type=style&index=0&id=77e1207c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e1207c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e1207c')) {
      api.createRecord('77e1207c', component.options)
    } else {
      api.reload('77e1207c', component.options)
    }
    module.hot.accept("./MovePrescriptionStartDateDialog.vue?vue&type=template&id=77e1207c&scoped=true", function () {
      api.rerender('77e1207c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/MovePrescriptionStartDateDialog.vue"
export default component.exports